module.exports = __webpack_public_path__ + "static/media/checked.bb8217dd.svg";